import {
  CiselnikPolozka as CiselnikPolozkaGenerated,
  CiselnikPolozkaExternalApi,
  TypCiselnikaEnum,
} from 'ciselniky-frontend-ts-axios';
import CiselnikPolozka from '../../model/CiselnikPolozka';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import { ciselnikyPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new CiselnikPolozkaExternalApi(apiConfiguration(ciselnikyPrefixPath));

function map(polozky: CiselnikPolozkaGenerated[]): CiselnikPolozka[] {
  return polozky
    .filter(polozka => polozka.nazov !== '')
    .map(polozka => ({
      uuid: polozka.uuid,
      nazov: polozka.nazov,
      platny: polozka.platny,
      kod: polozka.kod,
      legislativny: polozka.legislativny,
      existujeFormular: polozka?.existujeFormular,
      generovanySystemom: polozka?.generovanySystemom,
      povolitZadavanieFormularom: polozka?.povolitZadavanieFormularom,
    }));
}

// eslint-disable-next-line import/prefer-default-export
export const fetchCiselnikPolozky = async (
  ids: string[],
  typy: TypCiselnikaEnum[],
  platny: boolean,
  hladanyNazov: string,
  kody: string[],
  limit?: number,
  // eslint-disable-next-line default-param-last
  shouldFetch = true,
  headers?: object,
):
  Promise<ClientResponse<CiselnikPolozka[]>> => {
  if (!shouldFetch) {
    return {
      data: [],
      responseCode: null,
    };
  }
  const {
    data,
    status,
  } = await client.getCiselnikPolozka(ids, typy, platny, hladanyNazov, kody, limit, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
